import { Widget } from "@foretagsplatsen/widgetjs";
import OldSpinnerWidget from "../../deprecated/OldSpinnerWidget/OldSpinnerWidget.js"; // eslint-disable-line import-x/no-deprecated -- todo: migrate to new spinner
import state from "../state.js";

/**
 * Subclass from this widget when you need a widget that is populated
 * asynchronously. This abstract widget has 3 different states: "empty",
 * "updating", "loaded". Each state corresponds to a dedicated render method
 * that subclasses needs to override (especially the `_renderLoadedContentOn()
 * method).
 *
 * The widget starts in the "updating" state which renders a spinner widget by
 * default.
 *
 * The current state can be changed by using one of `_showEmpty()`,
 * `_showContent()` and `_showUpdating()`.
 *
 * @param {Renderable} [spinner] - Anything to show while the page is
 *   in updating state
 */
export default class AsyncStateWidget extends Widget {
	constructor({
		// eslint-disable-next-line import-x/no-deprecated -- todo: migrate to new spinner
		spinner = new OldSpinnerWidget({
			dark: true,
			size: 68,
		}),
	} = {}) {
		super(...arguments);

		this._state = state.updating;

		this._spinner = spinner;
	}

	renderContentOn(html) {
		this._state.renderDocumentOn({
			renderContentOn: () => this._renderLoadedContentOn(html),
			renderEmptyContentOn: () => this._renderEmptyContentOn(html),
			renderUpdatingContentOn: () => this._renderUpdatingContentOn(html),
		});
	}

	_renderLoadedContentOn() {}

	_renderUpdatingContentOn(html) {
		this._renderSpinnerOn(html);
	}

	_renderEmptyContentOn() {}

	_renderSpinnerOn(html) {
		html.div({ class: "row" }, this._spinner);
	}

	// eslint-disable-next-line no-shadow -- bad practice, we should fix this
	_setState(state) {
		this._state = state;
		this.trigger("stateChanged", this._state.label);
		this.update();
	}

	_showEmpty() {
		this._setState(state.empty);
	}

	_showUpdating() {
		this._setState(state.updating);
	}

	_showContent() {
		this._setState(state.loaded);
	}
}
